import React from "react";
import Text from "common/Typography/Text";
import Link from "common/Typography/Link";
import styled from "styled-components";
import { ResendEmailProps } from "@shared/features/onboarding/types";
import { SUPPORT_BOT_LINK } from "@shared/common/constants";

const ResendEmailInstructions = ({ isVerify, addBorder }: ResendEmailProps) => {
  const emailTypeText = isVerify ? "code" : "instructions";

  return (
    <Wrapper $addBorder={addBorder}>
      <Text>
        {`Didn't receive an email with the ${emailTypeText}? Make sure it’s not in the spam folder.
              If you can’t find it there, you can contact `}
        <Link href={SUPPORT_BOT_LINK} target="_blank">
          Cornix Support.
        </Link>
      </Text>
    </Wrapper>
  );
};

export default ResendEmailInstructions;

const Wrapper = styled.div<{ $addBorder?: boolean }>`
  width: 100%;
  margin-top: 20px;
  ${(p) =>
    p.$addBorder &&
    `
    border-top: ${p.theme.borders.medium};
    padding-top: 20px;
  `};
`;
